import React, { useState, useEffect } from "react";
import {
  Backdrop,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";

const ReloadAlert = ({ onReload }) => {
  const [countdown, setCountdown] = useState(10);
  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(true);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    } else if (!loading) {
      setLoading(true);
      setTimeout(() => {
        onReload();
      }, 5000);
    }
  }, [countdown, loading, onReload]);

  const handleCancel = () => {
    setShowDialog(false);
  };

  return (
    <>
      {showDialog && (
        <Dialog open={true}>
          <DialogTitle>Page Reload in {countdown} seconds</DialogTitle>
          <DialogContent>
            The page will reload soon to reflect the changes. You can cancel or
            choose to reload later.
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel} color="secondary">
              Cancel Reload
            </Button>
            <Button onClick={() => setCountdown(0)} color="primary">
              Reload Now
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {loading && (
        <Backdrop open={true} style={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
          <p>Making changes... Please wait</p>
        </Backdrop>
      )}
    </>
  );
};

export default ReloadAlert;
